import { Policy } from 'models/policies';

const nonActivePolicyStatus = ['DROPPED_OUT', 'CANCELED', 'CANT_BE_COVERED'];

export const getActivePolicies = (policies: Policy[]) =>
  policies.filter((policy) => !nonActivePolicyStatus.includes(policy.status));
